import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LandingLayout from "../layouts/LandingLayout/LandingLayout";
import DashboardLayout from "../layouts/DashboardLayout/DashboardLayout";
import { PrivateRoute } from "../components/PrivateRoute/PrivateRoute";
import Home from "../pages/landing/Home";
import AuthLayout from "../layouts/AuthLayout/AuthLayout";
import AdminLayout from "../layouts/AdminLayout/AdminLayout";
import Admin from "../pages/admin/Admin";
import Dashboard from "../pages/admin/Dashboard/Dashboard";
import Clients from "../pages/admin/Clients/Clients";
import Client from "../pages/admin/Client/Client";
import Login from "../pages/auth/login/Login";
import Register from "../pages/auth/registration/Register";
import Account from "../pages/dashboard/Account/Account";
import Profile from "../pages/dashboard/Profle/Profile";
import Education from "../pages/dashboard/Education/Education";
import FAQ from "../pages/dashboard/FAQ/FAQ";
import Main from "../pages/dashboard/Main/Main";
import News from "../pages/dashboard/News/News";
import Orders from "../pages/dashboard/Orders/Orders";
import Reports from "../pages/dashboard/Reports/Reports";
import Shop from "../pages/dashboard/Shop/Shop";
import Structure from "../pages/dashboard/Structure/Structure";
import Wallet from "../pages/dashboard/Wallet/Wallet";
import NotFound from "../pages/NotFound/NotFound";
import DashboardHome from "../pages/dashboard/Home/DashboardHome";
import PublicRoute from "../components/PrivateRoute/PublicRoute";
import ActivatedPage from "../pages/activated/ActivatedPage";
import AdminLogin from "../pages/admin/Login/AdminLogin";
import ActivatePage from "../pages/activated/ActivatePage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <LandingLayout />,
    children: [{ index: true, element: <Home /> }],
  },
  {
    path: "/auth",
    element: (
      <PublicRoute>
        <AuthLayout />
      </PublicRoute>
    ),
    children: [
      { path: "login", element: <Login /> },
      { path: "register", element: <Register /> },
      { path: "admin", element: <AdminLogin /> },
    ],
  },
  {
    path: "/main",
    element: (
      <PrivateRoute>
        <DashboardLayout />
      </PrivateRoute>
    ),
    children: [
      { index: true, element: <DashboardHome /> },
      { path: "account", element: <Account /> },
      { path: "education", element: <Education /> },
      { path: "faq", element: <FAQ /> },
      { path: "main", element: <Main /> },
      { path: "news", element: <News /> },
      { path: "orders", element: <Orders /> },
      { path: "profile", element: <Profile /> },
      { path: "reports", element: <Reports /> },
      { path: "shop", element: <Shop /> },
      { path: "structure", element: <Structure /> },
      { path: "wallet", element: <Wallet /> },
    ],
  },
  {
    path: "/admin",
    element: (
      <PrivateRoute>
        <AdminLayout />
      </PrivateRoute>
    ),
    children: [
      { index: true, element: <Admin /> },
      { path: "dashboard", element: <Dashboard /> },
      { path: "auth", element: <AdminLogin /> },
      { path: "clients", element: <Clients /> },
      { path: "client", element: <Client /> },
    ],
  },
  {
    path: "/activated/:id",
    element: <ActivatedPage />,
  },
  {
    path: "/activate",
    element: <ActivatePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default function AppRouter() {
  return <RouterProvider router={router} />;
}
